{
	"404": {
		"go-to-home-screen": "Gå til startskjermen",
		"this-screen-doesnt-exist": "Denne skjermen eksisterer ikke"
	},
	"flag": "🇳🇴",
	"common": {
		"add": "Legg til",
		"create": "Opprett",
		"e-mail": "E-post",
		"edit": "Redigere",
		"language": "Språk",
		"no": "Nei",
		"or": "Eller",
		"password": "Passord",
		"save": "Lagre",
		"select": "Velg",
		"selected": "Valgt",
		"select-all": "Velg alle",
		"selected-all": "Valgte alle",
		"sign-out": "Logg ut",
		"yes": "Ja",
		"saving": "Lagrer",
		"delete": "Slett",
		"next": "Neste",
		"get-started": "Kom i gang",
		"skip": "Hopp over",
		"optional": "valgfri",
		"read-more": "Les mer",
		"show-less": "Vis mindre",
		"cancel": "Avbryt",
		"search": "Søk",
		"send": "Sende",
		"done": "Ferdig",
		"password-requirements-hint": "Minst {{minLength}} tegn, ett tall, ett spesialtegn",
		"view-all": "Se alle",
		"back": "Tilbake",
		"steps-of-total": "{{completed}} av {{total}}",
		"more": "Mer",
		"beta": "beta",
		"block": "Blokkere",
		"ok": "Ok"
	},
	"connections": {
		"are-you-sure-you-want-to-remove-name-from-connections": "Er du sikker på at du vil fjerne tilknytningen til {{name}}?",
		"connect": "Koble til",
		"connections": "Tilkoblinger",
		"enter-the-information-about-user-to-bind-account-to-pletly-pal": "Skriv inn informasjonen om brukeren for å binde kontoen til Pletly Pal",
		"enter-the-information-about-user-to-create-account-in-pletly-pal": "Skriv inn den forespurte informasjonen for å opprette en bruker for Omsorgsmottakeren. \nDu vil bli tildelt eier rollen av den opprettede kontoen.",
		"oops-kinda-quiet-here": "Oops! \nHer var det stille!",
		"remove-name": "Fjern {{name}}",
		"to-be-able-to-use-pletly-pal-as-intended-and-see-resourcename-you-have-to-be-connected-to-one-or-more-users": "For å kunne bruke Pletly Pal som tiltenkt og se {{resourceName}} må du være koblet til en eller flere Omsorgsmottakere",
		"invites-of-your-proteges": "Invitasjoner fra Omsorgsmottaker",
		"tab-groups": "Grupper",
		"tab-users": "Brukere",
		"users-count_one": "{{count}} bruker",
		"users-count_other": "{{count}} brukere",
		"my-connections": "Tilknyttede personer",
		"create-group": "Lag gruppe",
		"name-group": "Navnegruppe",
		"edit-group-name": "Rediger gruppenavn",
		"are-you-sure-you-want-delete-group": "Er du sikker på at du vil slette gruppen {{name}}?",
		"delete-group": "Slett gruppe",
		"are-you-sure-you-want-remove-from-group": "Er du sikker på at du vil fjerne {{name}} fra gruppen?",
		"remove-user": "Fjern bruker",
		"add-friends-to-view-post": "Pletly er morsommere med andre brukere. Finn ut om noen av dine allerede har blitt med eller lag noen nye.",
		"sent-invites": "Sendte invitasjoner",
		"choose-how-you-want-to-connect-care-receiver": "Velg hvordan du vil koble til Omsorgsmottakeren. \nDu kan opprette en ny konto eller koble til en eksisterende.",
		"connect-new-care-receiver": "Koble til ny Omsorgsmottaker",
		"connect-to-care-receiver": "Koble til Omsorgsmottaker",
		"create-care-receiver": "Opprett Omsorgsmottaker",
		"create-care-receiver-account": "Opprett konto for Omsorgsmottaker",
		"who-sent-invite": "{{who}} sendte invitasjon",
		"connection-request-successfully-sent": "Tilkoblingsforespørsel er sendt",
		"new-request": "Ny forespørsel",
		"new-invitation": "Ny invitasjon",
		"create-another-care-recipient": "Opprett en annen Omsorgsmottaker",
		"invite-caregivers": "Inviter Omsorgspersoner",
		"created-account-successfully-for": "Du har opprettet en konto for {{name}}",
		"you-can-invite-others-to-connect-to": "Du kan invitere andre til å koble til {{name}} som Omsorgspersoner eller opprette en annen Omsorgsmottakerkonto.",
		"invite-others-to-connect-with": "Inviter andre inn i omsorgssirkelen til {{name}}",
		"enter-emails-of-caregivers-you-want-connect": "Skriv inn e-postadressene til omsorgspersonene du vil koble til {{name}}",
		"send-invitations": "Send invitasjoner",
		"invitations-to-become-caregiver": "Invitasjoner til å bli omsorgsperson",
		"invitations-to-connect": "invitasjoner til å koble til",
		"cancel-invitation": "Vil du avbryte invitasjonen?",
		"bravo-you-managed-create-account": "Bravo! Du klarte å opprette en konto for {{name}}",
		"users-count_few": "",
		"add-connection": "Legg til tilkobling",
		"oops-look-like-you-dont-have-any-connections": "Oops! \nDet ser ut til at du ikke har noen forbindelser.",
		"do-you-want-to-fill-information": "Ønsker du å fylle ut informasjon om omsorgsmottaker nå?",
		"add-information": "Fyll inn informasjon",
		"create-account-for-care-recipient": "Opprett konto for Omsorgsmottaker",
		"add-information-about-care-recipient": "Legg til informasjon om Omsorgsmottaker",
		"thank-you-additional-information-is-helpful": "Takk skal du ha!\nYtterligere informasjon er alltid nyttig!",
		"invite-family-members-to-be-connected-to": "Inviter familiemedlemmer til å bli koblet til {{ name }}.",
		"enter-the-email-addresses-of-the-family-members-that-youd-like-to-have-connected-to": "Skriv inn e-postadressene til familiemedlemmene du vil ha tilknytning til {{ name }}",
		"organisation-requests": "Organisasjonsforespørsler",
		"request-accepted": "Forespørsel akseptert",
		"care-receiver-is-now-part-of-the-organisation": "Omsorgsmottaker er nå en del av organisasjonen",
		"request-rejected": "Forespørsel avvist",
		"temporary-access": "Midlertidig tilgang",
		"transfer-name-to-organisation": "Overfør {{name}} til {{organisation}}"
	},
	"post": {
		"add-a-comment": "Legg til en kommentar",
		"are-you-sure-you-want-to-delete-this-post": "Er du sikker på at du vil slette dette innlegget?",
		"comments": "Kommentarer",
		"delete-post": "Slett innlegget",
		"likes": "Liker",
		"new": {
			"add-text": "Legg til tekst",
			"add-users": "Legg til brukere",
			"create-new-post": "Opprett nytt innlegg",
			"edit-post": "Rediger innlegg",
			"permission-to-access-camera-roll-is-required": "Tillatelse til å få tilgang til kamerarullen kreves",
			"post-privacy": "Synlighet for innlegg",
			"saving-post": "Lagrer innlegg",
			"and-others_one": "og {{count}} annen",
			"and-others_other": "og {{count}} andre",
			"your-post-is-being-published": "Innlegget ditt blir publisert...",
			"publish": "Publiser",
			"save-settings": "Lagre innstillinger",
			"publication-settings": "Publikasjonsinnstillinger",
			"your-care-recipients": "Dine Omsorgsmottakere",
			"search-care-recipients": "Søk Omsorgsmottakere",
			"errors": {
				"content-media-required": "Tekstinnhold eller media kreves",
				"privacy": "Velg minst én omsorgsmottaker"
			},
			"info": {
				"post-submitted-for-review": "Innlegget ditt er sendt inn for vurdering",
				"post-edited-and-resubmited-for-review": "Innlegget er redigert og sendt inn på nytt for vurdering"
			},
			"your-teams": "Lagene dine",
			"organisation": "Organisasjon",
			"all-employees": "Alle ansatte",
			"select": "Velge",
			"team": "Team ({{ count }})",
			"blur-faces": {
				"previous-photo": "Forrige bilde",
				"next-photo": "Neste bilde",
				"blur-faces-in-photos": "Skjul ansikter i bilder ({{ count }})",
				"add-a-photo-of-the-care-recipients-face-that-is-not-to-be-blured-out": "Legg til et bilde av omsorgsmottakers ansikt som ikke skal skjules.",
				"care-receiver-reference-photo": "Referansebilde for omsorgsmottaker",
				"blur-all": "Skjul alle"
			},
			"schedule-for-later": "Plan for senere",
			"to-be-published": "Skal publiseres",
			"date": "Dato",
			"time": "Tid",
			"show-scheduled-posts": "Se alle planlagte innlegg",
			"restrict-visibility-checkbox": "Begrens synligheten til kun profesjonelle Omsorgspersoner"
		},
		"post": "Post",
		"see-all-comments": "Se alle kommentarene",
		"selected-users": "Utvalgte brukere",
		"users-publications": "brukerens publikasjoner",
		"comment-actions": "Kommentarhandlinger",
		"delete-comment-content": "Er du sikker på at du vil slette kommentaren?",
		"delete-comment-title": "Vil du fjerne kommentaren?",
		"editing-comment": "Redigering av kommentar",
		"pin-post": "Fest Innlegg",
		"unpin-post": "Løsne innlegget",
		"pinned-post": "Festet innlegg",
		"welcome-post": {
			"swipe-left-to-learn-more": "Sveip til venstre for å lære mer om hva Pletly kan tilby.",
			"pletly-pal-offers-custom-made-biography": "Pletly tilbyr en skreddersydd biografi over alle dine Omsorgsmottakere.",
			"get-to-know-care-receivers": "Bli kjent med Omsorgsmottakerne",
			"information-library": "Informasjonsbibliotek",
			"you-can-easily-structure-necessary-information": "Du kan enkelt strukturere nødvendig informasjon om Omsorgsmottakeren. \nDette kan være videoer av tegnspråk eller fysiske øvelser.",
			"welcome-to-pletly": "Velkommen til Pletly!",
			"content": "Takk for at du ble med Pletly! \nVi er glade for å ønske deg velkommen til plattformen vår, der vi streber etter å forbedre kvaliteten på omsorgen og forbedre livene ved å fremme tettere forbindelser innenfor omsorgssirkelen og fremme personsentrisk omsorg.",
			"social-feed-content": "Få meningsfull innsikt i hverdagen til omsorgsmottakeren gjennom vår sosiale feed, samtidig som personvernet opprettholdes.",
			"social-feed-title": "Privat og sikker sosial feed"
		},
		"block-user": "Blokker bruker",
		"report-post": "Rapporter innlegg",
		"report-sent": "Rapport sendt",
		"we-will-review-your-report-shortly": "Vi vil vurdere rapporten din snart",
		"user-blocked": "Bruker blokkert",
		"are-you-sure-to-block-author-user": "Er du sikker på å blokkere {{user}} bruker?",
		"are-you-sure-to-report-this-post": "Er du sikker på å rapportere dette innlegget?",
		"this-will-hide-it-for-you-and-report-the-post-to-the-moderators": "Dette vil skjule det for deg og rapportere innlegget til moderatorene.",
		"you-will-not-see-content-from-this-user-anymore": "Du vil ikke se innhold fra denne brukeren lenger.",
		"adding-media": "Legger til media({{ count }})...",
		"book-post": {
			"new-book": "Ny bok"
		},
		"add-media": "Legg til media",
		"post-deleted": "Innlegg slettet",
		"review": {
			"approve": "Godta",
			"reject": "Avvis",
			"confirm-reject-modal": {
				"title": "Er du sikker på at du vil avvise innlegget til {{authorName}}?",
				"content": "Oppgi en begrunnelse for avvisningen av innlegget.",
				"reason-field-label": "Grunnen til",
				"reason-field-placeholder": "Skriv inn årsaken til avslaget her"
			},
			"posts-to-review-screen": {
				"subtitle": "Innlegg som venter på å bli godkjent",
				"title": "Godkjenning av innlegg"
			},
			"status": {
				"pending": "Avventer",
				"rejected": "Avvist",
				"approved": "Godkjent"
			},
			"review-submitted-successfully": "Status er oppdatert",
			"posts-submitted-screen": {
				"subtitle": "Innlegg som venter på å bli godkjent.",
				"title": "Godkjenning av innlegg",
				"reason": "Grunnen til"
			},
			"discard": "Kast",
			"edit": "Redigere",
			"menu": {
				"posts-under-review": "Innlegg under vurdering",
				"posts-to-review": "Godkjenn innlegg"
			}
		},
		"share": {
			"share": "Del",
			"share-post": "Del innlegget",
			"shared-post": "Delt innlegg",
			"shared-with": "Delt med {{ name }}",
			"post-has-been-sent-in-a-chat-message": "Innlegget er sendt i en chatmelding",
			"someone-shared-post": "{{ authorName }} har delt noe viktig med deg. \nKlikk her for å sjekke det ut."
		},
		"adding-media_zero": "Legger til media ...",
		"admin": "Admin",
		"errors": {
			"forbidden": {
				"title": "Tilgang nektet: Uautorisert tilgang",
				"message": "\nDet ser ut til at du ikke har tillatelse til å se dette innholdet fordi du ikke er knyttet til den aktuelle omsorgsmottakeren. \nDenne begrensningen er på plass for å beskytte personvernet til sensitiv informasjon.\n\nHvis du mener dette er en feil, vennligst sjekk tilkoblingene dine eller kontakt personen som delte innlegget for ytterligere hjelp."
			}
		},
		"blur-faces": "Skjul ansikter",
		"accept": "Aksepter",
		"add-file": "Legg til fil",
		"delete-file": "Slett fil",
		"are-you-sure-you-want-to-delete": "Er du sikker på at du vil slette {{ name }}?",
		"file-deleted": "Filen slettet",
		"file-has-been-deleted-successfully": "{{ name }} er slettet vellykket.",
		"filters": {
			"modal": {
				"title": "Filtre",
				"published-in": {
					"custom-label": "Tilpasset periode",
					"custom-placeholder": "Velg tilpasset periode",
					"label": "Publikasjonsdato",
					"option-days_one": "Siste dag",
					"option-days_other": "Siste {{count}} dager",
					"option-all-time": "Hele tiden"
				},
				"care-recipients": {
					"label": "Omsorgsmottakere",
					"no-care-recipients-to-select": "Ingen omsorgsmottakere å velge",
					"everyone": "Alle sammen",
					"selected-only": "Bare utvalgte"
				},
				"tags": {
					"label": "Tagger",
					"no-tags-selected": "Ingen tagger valgt",
					"available-tags": "Tilgjengelige tagger",
					"no-tags-available": "Ingen tagger tilgjengelig"
				}
			},
			"btn-show": "Vis filtre",
			"btn-reset": "Tilbakestill filtre"
		},
		"scheduled-posts": "Planlagte innlegg",
		"no-posts-scheduled": "Ingen innlegg planlagt",
		"publication-error-warning": "Dette innlegget klarte ikke å publisere. \nVennligst gå gjennom innlegget ditt og prøv igjen."
	},
	"profile": {
		"about-me": "Om meg",
		"are-you-sure-you-want-to-delete-profile-username-account-forever": "Er du sikker på at du vil slette {{username}}-kontoen for alltid?",
		"change-password": "Bytt passord",
		"delete-account": "Slett konto",
		"delete-profile-username-account": "Slett {{username}}-kontoen",
		"edit-information": "Rediger informasjon",
		"edit-profile": "Rediger profil",
		"new-password": "Nytt passord",
		"old-password": "Gammelt passord",
		"password-changed": "Passordet har blitt endret",
		"my-profile": "Min profil",
		"saving-new-password": "Lagrer nytt passord...",
		"saving-profile-photo": "Lagrer profilbildet ...",
		"saving-user-information": "Lagrer brukerinformasjon...",
		"show-activity": "Vis aktivitet",
		"critical": "Viktig",
		"positive": "Preferanser",
		"negative": "Utfordringer",
		"add-information": "Legg til informasjon",
		"send-message": "Sende melding",
		"connections": "Tilknyttede personer",
		"feed": "Feed",
		"about": "Om",
		"create-a-folder": "Opprett en mappe",
		"new-information-folder": "Ny informasjonsmappe",
		"folder-name": "Mappenavn",
		"edit-information-folder": "Rediger informasjonsmappe",
		"remove-folder": "Fjern mappen",
		"are-you-sure-remove-folder-name": "Er du sikker på at du vil fjerne informasjonsmappen {{name}}?",
		"add-folder-icon": "Legg til mappeikon",
		"edit-folder-icon": "Rediger mappeikon",
		"select-icon": "Velg ikon",
		"save-information": "Lagre informasjon",
		"edit-folder": "Rediger mappe",
		"add-information-icon": "Legg til informasjonsikon",
		"new-information": "Ny informasjon",
		"information-name": "Informasjonsnavn",
		"edit-information-icon": "Rediger informasjonsikon",
		"are-you-sure-remove-information-name": "Er du sikker på at du vil fjerne {{name}} informasjon?",
		"remove-information": "Fjern informasjon",
		"there-is-no-information-yet": "Det er ingen informasjon ennå.",
		"add-post-to-information": "Legg til innlegg til informasjon",
		"there-are-no-posts-in-information": "Det er ingen innlegg i informasjon.",
		"create-information": "Lag informasjon",
		"create-subfolder": "Opprett undermappe",
		"delete-caregiver-confirm-title": "Koble fra {{careGiverName}}",
		"delete-caregiver-confirm-content": "Er du sikker på at du vil fjerne {{careGiverName}}-tilkoblingen til {{careReceiverName}}?",
		"information-not-completed": "Denne Omsorgsmottakeren har ingen utfylt informasjon",
		"fill-information": "Fyll ut informasjon",
		"error-username-empty": "Brukernavnet kan ikke være tomt",
		"error-firstname-lastname-empty": "Fornavn og etternavn kan ikke være tomme",
		"information": "Informasjon",
		"repeat-new-password": "gjenta nytt passord",
		"this-action-cannot-be-undone": "Denne handlingen kan ikke angres",
		"improve-your-security-with-a-strong-password": "Forbedre sikkerheten din med et sterkt passord.",
		"passwords-do-not-match": "passordene er ikke like",
		"restricted-access": "Begrenset tilgang",
		"restricted-access-description": "Når den er deaktivert, vil brukeren kunne legge til innlegg og kommentarer, like, redigere og slette eksisterende.",
		"not-authorized-to-view-profile": "Du er ikke autorisert til å se denne profilen.",
		"would-you-like-to-invite-as-caregiver-for": "Vil du invitere {{careGiverName}} til å bli omsorgsperson for {{careReceiverName}}?",
		"invite": "Invitere",
		"invitation-sent": "Invitasjonen er sendt",
		"revoke": "Oppheve",
		"revoke-invitation-confirm-title": "Tilbakekalle invitasjonen?",
		"invitation-revoked": "Invitasjonen er tilbakekalt",
		"profile-saved": "Profilen er lagret",
		"invite-to-become-caregiver": "Inviter til å bli omsorgsperson",
		"new-password-must-be-different-from-the-old-one": "Det nye passordet må være forskjellig fra det gamle",
		"invalid-password": "Ugyldig passord",
		"folder-access": {
			"access": "Adgang",
			"access-to-the": "Tilgang til",
			"options": {
				"description-everyone": "Hver tilkoblet omsorgsperson vil ha tilgang til denne",
				"description-everyone-in-organisation": "Alle omsorgspersoner fra organisasjonen {{ organisationName }} vil ha tilgang til denne",
				"description-individual-caregivers": "Kun utvalgte omsorgspersoner vil ha tilgang til denne",
				"everyone": "Alle sammen",
				"everyone-in-organisation": "Alle i organisasjonen",
				"individual-caregivers": "Individuelle omsorgspersoner"
			},
			"set-access": "Angi tilgang",
			"caregiver-list": "Omsorgspersoner",
			"no-caregivers-to-select": "Ingen omsorgspersoner å velge",
			"access-settings-saved": "Tilgangsinnstillinger er lagret",
			"target-folder": "mappen",
			"target-information": "informasjon"
		},
		"invite-caregivers": "Inviter omsorgspersoner",
		"no-user-posts": "Ingen brukerinnlegg",
		"create-first-post-on-user-feed-to-get-started": "Lag første innlegg på brukerfeed for å komme i gang",
		"add-new-post": "Legg til nytt innlegg",
		"access-to-profile-expires": "Tilgang til denne profilen utløper",
		"no-care-recipients-available": "Ingen omsorgsmottakere tilgjengelig å velge",
		"files": "Filer",
		"files-table": {
			"name": "Navn",
			"creator": "Opprettet av",
			"created-at": "Opprettet",
			"connected-care-recipients": "Tilkoblede omsorgsmottakere"
		}
	},
	"validations": {
		"error": "Feil"
	},
	"onboarding": {
		"complete-your-account-setup": "Fullfør kontooppsettet",
		"what-is-your-name": "Hva heter du?",
		"first-name": "Fornavn",
		"last-name": "Etternavn",
		"pletly-pal-is-the-platform-connecting-caregivers-and-facilitate-communication-with-care-receivers": "Pletly Pal er plattformen som knytter Omsorgspersoner sammen og forenkler kommunikasjon med Omsorgsmottakere",
		"welcome-to-pletly-pal": "Velkommen\n til Pletly Pal",
		"welcome-to-pletly-care": "Velkommen\n til Pletly Care",
		"add-phone-number": "Legg til telefonnummer",
		"by-adding-your-phone-number-you-are-providing-other-caregivers-an-option-to-contact-you-outside-the-pletly-ecosystem": "Ved å legge til telefonnummeret ditt gir du andre omsorgspersoner muligheten til å kontakte deg utenfor Pletly-økosystemet",
		"add-connections": "Legg til tilkoblinger",
		"connect-with-existing-user": "Koble til eksisterende bruker",
		"create-account-for-care-receiver": "Opprett konto for Omsorgsmottaker",
		"create-new-account-for-a-care-receiver-or-connect-to-one-if-account-is-already-created": "Opprett ny konto for en Omsorgsmottaker eller koble til en hvis konto allerede er opprettet",
		"bio-card-description": "Kommuniser hvem du er og hva din rolle er til andre omsorgspersoner i Pletly-økosystemet.",
		"bio-card-title": "Fyll ut din bio",
		"connect-card-description": "For å kunne bruke Pletly Pal etter hensikten må du være koblet til en eller flere Omsorgsmottakere.",
		"connect-card-title": "Koble til Omsorgsmottaker",
		"name-card-description": "Oppgi for- og etternavn. \nDin identitet er viktig for å gi trygghet og ha kommunikasjon av høy kvalitet.",
		"name-card-title": "Legg til navnet ditt",
		"phone-card-description": "Hvis du gir oss telefonnummeret ditt, muliggjøres en ekstra kommunikasjonsform når det er nødvendig.",
		"phone-card-title": "Legg til telefonnummer",
		"photo-card-description": "Legg til bilde, for du er vakker!",
		"photo-card-title": "Legg til et profilbilde",
		"post-card-description": "Legg ut informasjon eller medier du ønsker å dele med andre omsorgspersoner i pleiemottakerens nettverk.",
		"post-card-title": "Legg ut noe",
		"add-another-post": "Legg til et nytt innlegg",
		"add-bio": "Legg til bio",
		"add-name": "Legg til navn",
		"add-phone": "Legg til telefon",
		"add-photo": "Legg til bildet",
		"add-post": "Legg til innlegg",
		"connect": "Koble",
		"connect-more": "Koble til mer",
		"edit-bio": "Legg til bio",
		"edit-name": "Rediger navn",
		"edit-phone": "Rediger telefonen",
		"edit-photo": "Rediger bilde",
		"complete-your-profile": "Fullfør profilen din",
		"congratulations": "Gratulerer!",
		"your-profile-is-complete": "Profilen din er komplett!",
		"profile-completed": "Profil fullført"
	},
	"lock": {
		"hello": "Hei",
		"or-just-use-password-instead": "eller bare bruk passord i stedet",
		"use-fingerprint-to-login-to-your-account": "Vi bryr oss om Omsorgsmottakernes personvern. Autentiser på nytt for å få tilgang til Pletly Pal.",
		"cant-unlock": "Kan du ikke låse opp?"
	},
	"conversations": {
		"conversation-details": "Samtaledetaljer",
		"group-name": "Gruppenavn",
		"group-participants": "Deltakere",
		"edit-chat": "Rediger chat",
		"add-chat": "Legg til chat",
		"chats": "Chatter",
		"sending-private-message": "Sender privat melding...",
		"my-chats": "Mine samtaler",
		"create-new-chat": "Opprett ny samtale",
		"create-group-chat": "Opprett gruppesamtale",
		"create": "Opprett",
		"screen-title": "Meldinger",
		"type-message-here": "Skriv melding her...",
		"messages-seen-by-name-on-when": "Meldinger sett av {{ name }} på {{ when }}",
		"report-message": "Rapporter melding",
		"edit-info": "For å redigere denne gruppechatten (legg til eller fjerne deltakere osv.), Trykk på blyantikonet i øverste høyre hjørne.",
		"access-messages": "Få tilgang til meldinger",
		"all-participants-in-the-chat-will-be-notified": "Alle deltakere i chatten vil bli varslet.",
		"to-access-the-content-of-this-chat-click-the-button-below-all-participants-in-the-chat-will-be-notified": "For å få tilgang til innholdet i denne chatten, klikker du på knappen nedenfor. \nAlle deltakere i chatten vil bli varslet.",
		"are-you-sure-to-report-this-message": "Er du sikker på at du vil rapportere denne meldingen?",
		"you-will-not-see-this-message-anymore-and-we-will-review-your-report-shortly": "Du vil ikke se denne meldingen lenger, og vi vil gjennomgå rapporten din om kort tid.",
		"are-you-sure-you-want-to-delete-this-conversation": "Er du sikker på at du vil slette denne samtalen?",
		"failed-to-delete-conversation": "Kunne ikke slette samtalen",
		"no-results": "Ingen resultater"
	},
	"menu": {
		"title": "Meny",
		"edit-profile": "Edit profile",
		"about-app": "Om appen",
		"settings-link": "Innstillinger",
		"log-out": "Logg ut",
		"settings": {
			"title": "Innstillinger",
			"notifications": {
				"title": "Varsler",
				"all-notifications": "Alle varsler",
				"new-post": "Nytt innlegg",
				"direct-message": "Direkte melding",
				"new-like-on-post": "Ny Like på innlegget",
				"new-comment-on-post": "Ny kommentar på innlegget"
			},
			"security": {
				"title": "Sikkerhet",
				"master-lock": "Hovedlås",
				"lock-description": "Pletly Pal-appen låses automatisk etter {{minutes}} minutter med inaktivitet og kan låses opp med TouchID, FaceID eller et passord."
			}
		},
		"communities": "Fellesskap",
		"switch-to-organisation-panel": "Bytt til organisasjonens panel",
		"my-files": "Mine filer"
	},
	"verification": {
		"an-email-has-been-sent-to": "En e-post er sendt til",
		"verify-email": "Verifiser e-post",
		"please-click-on-link-to-verify-your-email-address": "Vennligst klikk på lenken for å bekrefte e-postadressen din",
		"resend-email": "Send e-post på nytt",
		"sent-please-check-your-email": "Sendt, sjekk e-posten din",
		"your-email-has-been-successfully-verified": "E-posten din har blitt bekreftet."
	},
	"paywall": {
		"activate-premium": "Aktiver premium",
		"create-up-to-n-care-receivers-and-enjoy-unlimited-number-of-connections": "Opprett opptil {{count}} Omsorgsmottakere og åpne for ubegrenset antall tilkoblinger",
		"maybe-later": "Kanskje senere",
		"subscribe": "Abonnere",
		"you-can-cancel-your-subscription-at-anytime": "Du kan si opp abonnementet ditt når som helst",
		"try-premium": "Prøv premium",
		"get-premium": "Få premium",
		"get-started": "Kom i gang",
		"get-premium-and-enjoy-an-unlimited-number-of-connections": "Få premium og nyt et ubegrenset antall tilkoblinger",
		"for-the-first": "Først og fremst",
		"periods": {
			"day_one": "dag",
			"day_other": "{{count}} dager",
			"month_one": "måned",
			"month_other": "{{count}} måneder",
			"year_one": "år",
			"year_other": "{{count}} år"
		},
		"then": "deretter"
	},
	"add-image": {
		"select-photo-from-gallery": "Velg bilde fra galleriet",
		"take-photo": "Ta et bilde",
		"record-video": "Ta opp en video",
		"permission-to-access-camera-roll-is-required": "Tillatelse til å få tilgang til kamerarull er nødvendig!"
	},
	"header": {
		"home": "Hjem",
		"connections": "Forbindelser",
		"notifications": "Varsler",
		"messages": "Meldinger",
		"search-for-connections": "Søk etter forbindelser",
		"communities": "Fellesskap",
		"ai": "AI"
	},
	"notifications": {
		"there-are-no-notifications": "Det er ingen varsler.",
		"no-new-updates-right-now-youll-be-the-first-to-know-when-theres-something-new": "Ingen nye oppdateringer akkurat nå. \nDu vil være den første som får vite når det er noe nytt."
	},
	"community": {
		"create-new-community": "Opprett nytt fellesskap",
		"community-name": "Fellesskapsnavn",
		"add-name-here": "Legg til navn her...",
		"community-description": "Beskrivelse",
		"add-description-here": "Legg til beskrivelse her...",
		"privacy-settings": "Personverninnstillinger",
		"pick-privacy-setting": "Velg personverninnstilling",
		"admins": "Administratorer",
		"communities": "Fellesskap",
		"community-members": "Fellesskapsmedlemmer",
		"create-new-post": "Opprett nytt innlegg",
		"explore": "Utforske",
		"find-users-to-add": "Finn brukere å legge til",
		"invite": "Invitere",
		"invite-to-community": "Inviter til fellesskapet",
		"invite-users": "Inviter brukere",
		"join": "Bli med",
		"leave": "Forlat",
		"make": "Gjør",
		"manage-members": "Administrer medlemmer",
		"members": "medlemmer",
		"private": "Privat",
		"public": "Offentlig",
		"your-communities": "Dine fellesskap",
		"add-post-to-the-community": "Legg til innlegg i fellesskapet...",
		"join-owner": "Eieren",
		"joined": "Ble med",
		"are-you-sure-you-want-to-make-this-group-privacy": "Er du sikker på at du vil gjøre denne gruppen til {{privacy}}?",
		"change-group-visibility": "Endre gruppesynlighet",
		"community-you-belong-to": "Fellesskapet du tilhører",
		"invitations": "Invitasjoner",
		"community-you-manage": "Fellesskapet du administrerer",
		"group-visibility-updated": "Gruppesynlighet oppdatert",
		"join-request-sent": "Bli med forespørsel sendt",
		"your-request-has-been-sent-to-the-community-owner": "Forespørselen din er sendt til fellesskapets eier",
		"leave-community": "Forlat fellesskapet",
		"delete-community": "Slett fellesskap",
		"are-you-sure-you-want-to-delete": "Er du sikker på at du vil slette {{ name }}?",
		"invites-sent": "Invitasjoner sendt",
		"invited": "Invitert",
		"admin-removed": "Admin fjernet",
		"are-you-sure-you-want-to-leave-this-community": "Er du sikker på at du vil forlate dette fellesskapet?",
		"invite-removed": "Invitasjonen er fjernet",
		"admin-added": "Admin er lagt til",
		"are-you-sure-you-want-to-remove-member": "Er du sikker på at du vil fjerne {{name}}?",
		"member-removed": "Medlemmet er fjernet",
		"remove-member": "Fjern medlem"
	},
	"summarization": {
		"from-date-until-date": "fra {{fromDate}} til {{toDate}}",
		"generate-summary": "Generer sammendrag av innlegg",
		"generating-summary": "Genererer sammendrag...",
		"no-posts-to-summarize": "Ingen innlegg å oppsummere for denne perioden",
		"posts-summary": "Oppsummering av innlegg",
		"select-dates": "Velg datoer",
		"select-from-date": "Velg fra dato",
		"select-to-date": "Velg til dato",
		"summarize-posts": "Oppsummer innlegg",
		"warning-text": "Innhold generert av AI kan inneholde unøyaktigheter. Bruk skjønn og kontroller viktige fakta.",
		"key-insights": "Innsikt",
		"suggestions": "Forslag",
		"mood": "Humør"
	},
	"zod": {
		"only-letters-numbers-and-underscores-are-allowed": "Bare bokstaver, tall og understrek er tillatt"
	},
	"no-information-folders": "Ingen informasjonsmapper",
	"create-your-first-folder-to-get-started": "Opprett din første mappe for å komme i gang",
	"undo": "Angre",
	"edit-profile-form": {
		"receive-summary-notification-emails": "Få oppsummering på e-post"
	},
	"upload-new-file": "Last opp ny fil"
}
